

















































import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
  props: {
    username: String,
    password: String,
    error: Boolean
  }
})
export default class LoginPage extends Vue {
  username!: string;
  password!: string;
  error!: boolean;

  login(username: any, password: any) {
    if (
      username == process.env.VUE_APP_ADMIN_USERNAME &&
      password == process.env.VUE_APP_ADMIN_PWD
    ) {
      this.$store.commit("setAuthentication", true);
      this.$router.replace({ name: "selectBarber" });
    }
  }
}
